export default [
  {
    path: "/administration/useraccount",
    name: "user-account",
    component: () => import("@/views/administration/userAccount/UserAccountList.vue"),
    meta: {
      // requiresAuth: true,
      pageTitle: "User Account List",
      action: "view",
      resource: "user-account",
      breadcrumb: [
        {
          text: "User Account",
          active: true
        }
      ]
    }
  },  
  {
    path: "/administration/useraccount/create",
    name: "create-user-account",
    component: () => import("@/views/administration/userAccount/FormUserAccount.vue"),
    meta: {
      pageTitle: "Create User Account",
      resource: "user-account",
      action: "create",
      // requiresAuth: true,
      breadcrumb: [
        {
          text: "User Account",
          active: true
        }
      ]
    }
  },  {
    path: "/administration/useraccount/edit/:userCode",
    name: "update-user-account",
    component: () => import("@/views/administration/userAccount/FormUserAccount.vue"),
    meta: {
      // requiresAuth: true,
      pageTitle: "Update User Account",
      resource: "user-account",
      action: "update",
      breadcrumb: [
        {
          text: "User Account",
          active: true
        }
      ]
    }
  },
  {
    path: "/administration/agent",
    name: "agent",
    component: () => import("@/views/administration/agent/AgentList.vue"),
    meta: {
      // requiresAuth: true, 
      resource: "agent",
      action: "view",
      pageTitle: "Agent List",
      breadcrumb: [
        {
          text: "Administration",
          active: true
        },
        {
          text: "Agent",
          active: true
        }
      ]
    }
  },
  {
    path: "/administration/trxtype",
    name: "trxtype",
    component: () => import("@/views/administration/trxType/TrxTypeList.vue"),
    meta: {
      // requiresAuth: true,
      resource: "trxtype",
      action: "view",
      pageTitle: "Transaction Type List",
      breadcrumb: [
        {
          text: "Transaction Type",
          active: true
        }
      ]
    }
  },
  {
    path: "/administration/setting",
    name: "setting",
    component: () => import("@/views/administration/settings/SettingList.vue"),
    meta: {
      // requiresAuth: true,
      action: "view",
      resource: "setting",
      pageTitle: "Settings List",
      breadcrumb: [
        {
          text: "Settings",
          active: true
        }
      ]
    }
  } , 
  {
    path: "/administration/line",
    name: "line",
    component: () => import("@/views/administration/line/LineList.vue"),
    meta: {
      // requiresAuth: true,
      pageTitle: "Line List",
      action: "view",
      resource: "line",
      breadcrumb: [
        {
          text: "Administration",
          active: true
        },
        {
          text: "Line User",
          active: true
        }
      ]
    }
  },
];
